var _rect, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 101,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.498,
    height: 58.034,
    x: 0.642,
    y: 42.244,
    fill: "#2F5FAD",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9E4F7",
    d: "M.5 55.464h89.64v9.673H.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37.48,
    height: 14.31,
    x: 9.145,
    y: 77.361,
    fill: "#D9E4F7",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 89.498,
    height: 58.034,
    x: 20.201,
    y: 26,
    fill: "url(#success_svg__a)",
    rx: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.024,
    height: 11.492,
    x: 88.169,
    y: 37.538,
    fill: "url(#success_svg__b)",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9E4F7",
    fillRule: "evenodd",
    d: "M28.662 40.63a1 1 0 0 0-1 1v3.308a1 1 0 0 0 1 1h33.566a1 1 0 0 0 1-1V41.63a1 1 0 0 0-1-1zm0 20.5a1 1 0 0 0-1 1v4.014a1 1 0 0 0 1 1h19.045a1 1 0 0 0 1-1v-4.015a1 1 0 0 0-1-1zm25.856 1a1 1 0 0 1 1-1h19.82a1 1 0 0 1 1 1v4.014a1 1 0 0 1-1 1h-19.82a1 1 0 0 1-1-1zm27.875-1a1 1 0 0 0-1 1v4.014a1 1 0 0 0 1 1h19.8a1 1 0 0 0 1-1v-4.015a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#success_svg__c)",
    d: "M52.164 13.19a1 1 0 0 1 .586.91v11.292c0 15.642-9.748 29.733-24.408 35.23a.98.98 0 0 1-.684 0C12.998 55.125 3.25 41.034 3.25 25.392V14.1a1 1 0 0 1 .586-.91l23.75-10.806a1 1 0 0 1 .828 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.325 62.775C11.575 57.145 1 42.056 1 25.39V13.456q0-1.352 1.35-2.027L27.1.169c.675-.225 1.35-.225 1.8 0l24.75 11.26q1.35.675 1.35 2.027V25.39C55 42.056 44.425 57.145 28.675 63c-.45 0-.9 0-1.35-.225M5.5 14.807v10.584c0 14.639 9 27.7 22.5 32.88 13.5-5.405 22.5-18.467 22.5-32.88V14.807L28 4.673z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M16.3 33.048c-.9-.9-.9-2.252 0-3.153.9-.9 2.25-.9 3.15 0l5.175 5.18L36.55 23.14c.9-.9 2.25-.9 3.15 0 .9.901.9 2.253 0 3.153L26.2 39.804c-.9.901-2.25.901-3.15 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "success_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(145.182 46.777 31.02)scale(92.0505 80.2517)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "success_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(140.803 43.604 37.06)scale(17.0437 14.5812)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "success_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.51777 54.88017 -46.66964 -37.00715 44.92 5.687)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })))));
};
export default SvgSuccess;